import { href, useNavigate } from 'react-router';

import { useMutation } from '@tanstack/react-query';

import { ROUTES } from '~shared/routes';

import { postAfterOTP, postResetToken } from '../api';
import { ResetTokenFormData } from './reset-token.schema';

/* The success message stays visible for a moment before the redirect. */
const REDIRECT_DELAY_MS = 1000;

type UsePostResetTokenParams = {
  pharmacyId: string;
  token?: string;
  isOTP: boolean;
};

export const usePostResetToken = ({
  pharmacyId,
  token,
  isOTP,
}: UsePostResetTokenParams) => {
  const navigate = useNavigate();

  const mutation = useMutation({
    mutationFn: (formData: ResetTokenFormData) =>
      isOTP
        ? postAfterOTP(pharmacyId, formData)
        : postResetToken(pharmacyId, formData, token!),

    onSuccess: () => {
      setTimeout(() => {
        navigate(
          href(isOTP ? ROUTES.dashboard : ROUTES.auth.login, { pharmacyId })
        );
      }, REDIRECT_DELAY_MS);
    },
  });

  return {
    submitNewPassword: mutation.mutate,
    reset: mutation.reset,
    isPending: mutation.isPending,
    isSuccess: mutation.isSuccess,
    isError: mutation.isError,
  };
};
